import { GetStaticProps } from 'next';
import React from 'react';

import CoreLayout from '@jpp/layouts/CoreLayout';
import Policy from '@jpp/templates/Policy';
import { SITE_DESCRIPTION } from 'common/utils/constants';

const TermsAndConditions: React.FunctionComponent = () => {
  const title = 'Terms and Conditions';

  return (
    <CoreLayout title={title} description={SITE_DESCRIPTION}>
      <Policy id="96d8c79c-19e2-46d1-ad3f-30b226c00e16" title={title} />
    </CoreLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default TermsAndConditions;
